// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"d4d426f3","443":"8a9b4efd","513":"cb80ca51","629":"0630ed41","790":"2f7f55f7","834":"bd9fef09","883":"c52f77ee","954":"5dacb7d5"}[chunkId] + ".chunk.js";
};